import { render } from "./upgradeButton.vue?vue&type=template&id=22afa952&scoped=true"
import script from "./upgradeButton.vue?vue&type=script&lang=js"
export * from "./upgradeButton.vue?vue&type=script&lang=js"

import "./upgradeButton.vue?vue&type=style&index=0&id=22afa952&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22afa952"]])

export default __exports__